<template>
  <div class="register-container">
    <el-card class="register-card">
      <div slot="header">
        <span>注册</span>
      </div>
      <el-form :model="registerForm" :rules="rules" ref="registerForm">
        <el-form-item prop="username">
          <el-input v-model="registerForm.username" placeholder="用户名">
            <i slot="prefix" class="el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="registerForm.password" placeholder="密码">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="registerForm.email" placeholder="邮箱">
            <i slot="prefix" class="el-icon-message"></i>
            <el-button slot="append" @click="sendVerificationCode" :disabled="cooldown > 0">
              {{ cooldown > 0 ? `${cooldown}s` : '发送验证码' }}
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="registerForm.code" placeholder="验证码">
            <i slot="prefix" class="el-icon-key"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleRegister" style="width: 100%" class="register-button">注册</el-button>
        </el-form-item>
        <div class="register-footer">
          <span>已有账号？</span>
          <el-button type="text" @click="$router.push('/login')" class="login-link">立即登录</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { register, sendEmail } from '@/api'

export default {
  name: 'Register',
  data() {
    return {
      registerForm: {
        username: '',
        password: '',
        email: '',
        code: ''
      },
      cooldown: 0,
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    async sendVerificationCode() {
      if (!this.registerForm.email) {
        this.$message.warning('请先输入邮箱地址')
        return
      }
      try {
        await sendEmail(this.registerForm.email)
        this.$message.success('验证码已发送')
        this.cooldown = 60
        const timer = setInterval(() => {
          this.cooldown--
          if (this.cooldown <= 0) {
            clearInterval(timer)
          }
        }, 1000)
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message
        this.$message.error(message || '发送验证码失败')
      }
    },
    handleRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (valid) {
          try {
            await register(this.registerForm)
            this.$message.success('注册成功')
            this.$router.push('/login')
          } catch (error) {
            const message = error.response && error.response.data && error.response.data.message
            this.$message.error(message || '注册失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - var(--header-height) - 6rem);
  padding: 1rem;
}
.register-card {
  width: min(100%, 400px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.register-button {
  background-color: #409EFF;
  border-color: #409EFF;
  font-size: 16px;
  height: 40px;
  font-weight: 500;
}
.register-button:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}
.register-footer {
  text-align: center;
  margin-top: 20px;
  color: #606266;
}
.login-link {
  color: #409EFF;
  font-weight: 500;
  font-size: 14px;
}
.login-link:hover {
  color: #66b1ff;
}
/* 发送验证码按钮样式 */
.el-button--default {
  color: #409EFF;
  border-color: #409EFF;
  background-color: #fff;
}
.el-button--default:hover {
  color: #66b1ff;
  border-color: #66b1ff;
}
.el-button--default:disabled {
  color: #c0c4cc;
  border-color: #e4e7ed;
  background-color: #fff;
}
</style>
